import { formatDistanceToNow } from 'date-fns';

export function formatRelativeTime(value?: string | null): string {
  if (!value) return 'recently';
  return formatDistanceToNow(new Date(value), { addSuffix: true });
}

export function formatUkDate(value?: string | null): string {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
